import React from 'react'
import { BaseModalComponentType, ModalNameToModalMap } from '../types'
import { MediaPreviewModal as BaseMediaPreviewModal } from 'shared'
import { withModal } from 'utils/providers/ModalProvider'

const MediaPreviewModal = ({
  closeModal,
  isOpen,
  payload: { url },
}: BaseModalComponentType & {
  payload: ModalNameToModalMap['mediaPreview']
}) => {
  return (
    <BaseMediaPreviewModal closeModal={closeModal} open={isOpen} url={url} />
  )
}

export default withModal('mediaPreview')(MediaPreviewModal)
